import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  UPDATE_EXPENSE_SUCCESS,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS, CREDIT_HISTORY_CHANGED,
} from './../../actions/types'

const INIT_STATE = null

export const getCreditHistory = (state) => {
  return state || INIT_STATE
}

const creditHistory = (state=INIT_STATE, {type, payload}) => {
  switch (type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return payload.applicationFlow.loanApplicationUser.creditHistory || state

    case CREDIT_HISTORY_CHANGED:
      return payload

    case UPDATE_EXPENSE_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.creditHistory !== undefined) {
        return payload.creditHistory || null
      } else {
        return state
      }
    default:
      return state;
  }
}

export default creditHistory
